/* eslint-disable max-lines */
import styled, { keyframes } from 'styled-components'
import { colorTheme } from '../../../../../../style/theme/colorTheme'
import { theme } from '../../../../../../style/theme'


export const ProductQuantity = styled.div`
  margin-left: 0.38em;
  color: ${colorTheme.cart.cartProduct.productQuantity};
  font-family: ${theme.fontRobotoBold};
  white-space: nowrap;

	&.secondary {
		color: ${colorTheme.cart.cartProduct.textSecondary};
	}

	&.disabled {
		color: ${colorTheme.cart.cartProduct.disabled};
	}
`
ProductQuantity.displayName = 'ProductQuantity'

export const ToppingWrap = styled.div`
	display: grid;
	align-items: center;

	&.touchPad {
		display: flex;
		gap: 1px;
		height: 2.13em;
		margin-bottom: 0.56em;
		margin-right: 0.31em;
	}
`
ToppingWrap.displayName = 'ToppingWrap'

export const Topping = styled.div`
	padding: 0.31em 0 0.31em 1.2em;
	border-top: solid 1px ${colorTheme.cart.cartProduct.topping.borderTop};
	display: grid;
	grid-template-columns: 2.63em 1fr 2.63em;
	align-items: center;
	gap: 0.25em;

	&.touchPad {
		padding: 0.31em;
		border-radius: 0.75em;
		background-color: ${colorTheme.cart.cartProduct.topping.background};
		border: solid 1px ${colorTheme.cart.cartProduct.topping.borderTouchPad};
		display: flex;
		justify-content: space-between;
		align-items: center;
		min-height: 2em;
		gap: 0;

		&.minus {
			border: 1px solid ${colorTheme.cart.cartProduct.topping.minus.border};
			display: flex;
			background-color: ${colorTheme.cart.cartProduct.topping.minus.background};
		}

		&.noRoundCorner {
			border-radius: 0;
			margin-bottom: 0;
			margin-right: 0;
		}

		&.noRoundCornerLeft {
			border-radius: 0 .73em .73em 0;
			margin-bottom: 0;
			margin-right: 0;
		}
	}

	&.strikethrough {
		text-align: center;

		> div {
			position: relative;
		}

		> div::after {
			content: "";
			position: absolute;
			bottom: 50%;
			left: -5px;
			right: -5px;
			width: 100%;
			height: 2px;
			background: linear-gradient(to right, ${colorTheme.cart.cartProduct.strikethrough} 50%, transparent 50%);
			background-size: 6px 2px;
		}
	}

	@media screen and (max-width: ${theme.point820}) {
		&.touchPad {
			margin-bottom: 0.31em;
		}
	}
`
Topping.displayName = 'Topping'

export const ToppingCol = styled.div`
  display: flex;
  align-items: center;
  font-size: 0.81em;
  line-height: 1.15em;
  font-family: ${theme.fontRobotoRegular};
  color: ${colorTheme.cart.cartProduct.topping.text};

  &.touchPad {
    font-size: 0.88em;
    margin-left: 0.21em;
  }
`
ToppingCol.displayName = 'ToppingCol'

export const ToppingName = styled(ToppingCol)`
	color: ${colorTheme.cart.cartProduct.topping.name};

	svg {
    width: 1em;
    height: 1em;
    border: none;
    cursor: pointer;
    display: flex;
    fill: ${colorTheme.cart.cartProduct.topping.icon};
    margin-right: 0.46em;
  }

	&.touchPad {
		color: ${colorTheme.cart.cartProduct.topping.touchPad.name};

		svg {
			fill: ${colorTheme.cart.cartProduct.topping.touchPad.icon};
		}

		&.secondary svg {
			fill: ${colorTheme.cart.cartProduct.textSecondary};
		}
		&.minus svg{
			fill: ${colorTheme.cart.cartProduct.topping.minus.text};
		}
	}

  &.secondary {
    color: ${colorTheme.cart.cartProduct.textSecondary};
  }

  &.minus {
    color: ${colorTheme.cart.cartProduct.topping.minus.text};
  }
`
ToppingName.displayName = 'ToppingName'

export const ToppingPrice = styled(ToppingCol)`
	color: ${colorTheme.cart.cartProduct.topping.price.text};
	&.touchPad {
    border-radius: 0.64em;
    background-color: ${colorTheme.cart.cartProduct.topping.price.background};
    padding: 0.33em;
    font-size: 0.75em;
    color: ${colorTheme.cart.cartProduct.topping.price.text};
    margin-left: 0.42em;
  }
`
ToppingPrice.displayName = 'ToppingPrice'

export const ToppingTotal = styled(ToppingCol)`
	&.touchPad {
    display: none;
  }
`
ToppingTotal.displayName = 'ToppingTotal'

export const ToppingMinus = styled.div`
  width: 1em;
  height: 1em;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colorTheme.cart.cartProduct.topping.removeButton};
  border-radius: 50%;
	margin-left: auto;

  > svg {
    width: 50%;
  }

  &.touchPad {
    width: 1.44em;
    height: 1.44em;
    border-radius: 0.56em;
    background-color: ${colorTheme.cart.cartProduct.topping.removeButtonTouchPad};
    margin-left: 0.31em;
    margin-right: 0;

		&.disabled {
			background-color: ${colorTheme.cart.cartProduct.topping.removeButton};
			cursor: initial;
		}

    &.minus {
      background-color: ${colorTheme.cart.cartProduct.topping.minus.removeButton};
    }
  }
`
ToppingMinus.displayName = 'ToppingMinus'

export const ToppingBack = styled.div`
	font-size: 1rem;
  width: 1.25em;
  height: 1.25em;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colorTheme.cart.cartProduct.topping.backButton};
	border-radius: .75em;
	margin-left: auto;

  > svg {
    width: 50%;
  }

  &.touchPad {
		width: 2em;
		height: 100%;
		padding: 0 .43em;
		border-radius: 0 .75em .75em 0;
		background-color: ${colorTheme.cart.cartProduct.topping.backButton};

		> svg {
			width: 1em;
			height: 1em;
		}

		&.disabled {
			background-color: ${colorTheme.cart.cartProduct.topping.backButton};
			cursor: initial;
		}

    &.back {
      background-color: ${colorTheme.cart.cartProduct.topping.backButton};
    }
  }
`
ToppingBack.displayName = 'ToppingBack'

export const ToppingInfo = styled.div`
	width: 1.2em;
	height: 1.2em;
	border: none;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${colorTheme.cart.cartProduct.topping.infoButton};
	border-radius: .75em;

	> svg {
		width: 50%;
	}

	&.touchPad {
		display: flex;
		width: 2em;
		height: 100%;
		padding: 0 .3em 0 .56em;
		border-radius: .75em 0 0 .75em;
		align-items: center;
		gap: .38em;
		background-color: ${colorTheme.cart.cartProduct.topping.infoButton};

		> svg {
			width: 1.13em;
			height: 1.13em;
		}
	}
`
ToppingInfo.displayName = 'ToppingInfo'

export const CartProductDishCourseWrap = styled.div`
  display: grid;
	grid-template-columns: 1fr;
	align-items: center;

	&.lf-col-2 {
		grid-template-columns: 3.12em 1fr;
	}

  &.active {
    & + div > div {
      border-top-color: transparent;
    }

		&:last-child > div:last-child {
			border-bottom-color: ${colorTheme.cart.cartProduct.active.border};
		}
  }

  &:last-child > div:last-child {
    border-bottom-color: ${colorTheme.cart.cartProduct.border};
  }

	&.menu div > div {
		border: transparent;
	}

	&.disabled {
		&:last-child > div:last-child {
			border-bottom-color: ${colorTheme.cart.cartProduct.error};
		}
	}

	@media screen and (max-width: ${theme.point720}) {
		&.lf-col-2 {
			grid-template-columns: auto 1fr;
		}
	}
`
CartProductDishCourseWrap.displayName = 'CartProductDishCourseWrap'


export const ProductMessageText = styled.div`
	color: ${colorTheme.cart.cartProduct.error};
	font-size: 0.94em;
	font-weight: 400;
	grid-column: 2 / 6;

	@media screen and (max-width: ${theme.point720}) {
		font-size: 0.88em;
	}
`
ProductMessageText.displayName = 'ProductMessageText'

const scroll = keyframes`
	0% {
		width: 0;
	}
	100% {
		width: 100%;
	}
`

export const DisabledProgress = styled.div`
	height: 0.44em;
	width: 100%;
	background-color: ${colorTheme.cart.cartProduct.error};
	position: absolute;
	left: 0;
	bottom: 0;
	animation: 7s ${scroll} 0s linear infinite;
`
DisabledProgress.displayName = 'DisabledProgress'

export const ToppingContent = styled.div`
	display: grid;
	grid-template-columns: 2fr 1fr 1fr;
	align-items: center;

	position: relative;

	&.strikethrough {
		text-align: center;

		> div {
			position: relative;
		}

		&::after {
			content: "";
			position: absolute;
			bottom: 50%;
			left: -5px;
			right: -5px;
			width: auto;
			height: 2px;
			background: linear-gradient(to right, ${colorTheme.cart.cartProduct.strikethrough} 50%, transparent 50%);
			background-size: 6px 2px;
		}
	}
`
ToppingContent.displayName = 'ToppingContent'
